import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _class, _temp;

import React, { Component } from 'react';
import { ThemeProvider, withTheme } from 'styled-components';
import GridColumn from './internal/GridColumnElement';
import { defaultGridColumns } from './internal/vars';
const defaultSpacing = 'cosy';
export default withTheme((_temp = _class = class AkGridColumn extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getTheme", props => ({
      columns: props.theme && props.theme.columns ? props.theme.columns : defaultGridColumns,
      spacing: props.theme && props.theme.spacing ? props.theme.spacing : defaultSpacing,
      isNestedGrid: false
    }));

    _defineProperty(this, "getNestedTheme", props => ({
      columns: props.medium,
      spacing: props.theme && props.theme.spacing ? props.theme.spacing : defaultSpacing,
      isNestedGrid: true
    }));
  }

  render() {
    return /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: this.getTheme(this.props)
    }, /*#__PURE__*/React.createElement(GridColumn, {
      medium: this.props.medium
    }, /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: this.getNestedTheme(this.props)
    }, /*#__PURE__*/React.createElement("div", null, this.props.children))));
  }

}, _defineProperty(_class, "defaultProps", {
  medium: 0
}), _temp));